import styled from 'styled-components';

/**
 * Shared form styles used across multiple screens
 * These styles were originally in TutorSignUp.css but are used in multiple components
 */

// Terms and Conditions Checkbox
export const Terms = styled.label`
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 15px 0;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  position: relative;
  padding-left: 25px;
  display: block;
  cursor: pointer;
  
  input {
    position: absolute;
    top: -1px;
    left: 0;
    cursor: pointer;
  }
`;

// Button Row Layout
export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing.lg};
  gap: ${({ theme }) => theme.spacing.md};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
  }
`;

// Back Button
export const BackButton = styled.button`
  display: block;
  margin: 0;
  max-width: 95px;
  max-height: 40px;
  box-sizing: border-box;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: 100%;
    width: 100%;
  }
`;

// Next Button
export const NextButton = styled.button`
  display: block;
  margin: 0;
  max-width: 95px;
  max-height: 40px;
  box-sizing: border-box;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: 100%;
    width: 100%;
  }
`;

// Container Title (used in multiple forms)
export const ContainerTitle = styled.h1`
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 100%;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  padding-bottom: 37px;
  margin: 0;
`;

// Instruction Text
export const InstructionText = styled.p`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  line-height: 100%;
  color: ${({ theme }) => theme.colors.textMuted};
  padding-bottom: ${({ theme }) => theme.spacing.md};
  margin: 0;
`;

// Side by Side Layout
export const LayoutSideBySide = styled.div`
  display: flex;
  flex-direction: row;
  gap: 22px;
  
  > *:not(.react-datepicker__tab-loop) {
    flex: 1 1 calc(50% - 11px);
    min-width: 0;
    box-sizing: border-box;
  }
  
  .react-datepicker__tab-loop {
    position: fixed;
    z-index: 1;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.md};
    
    > *:not(.react-datepicker__tab-loop) {
      flex: 1 1 100%;
    }
  }
`;

// Error Text (commonly used in forms)
export const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.errorRed};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  margin-top: ${({ theme }) => theme.spacing.xs};
  margin-bottom: 0;
`;